import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

import { LoadingSpinner } from "../LoadingSpinner";
import style from "./GetBOMAction.module.scss";

export interface GetBOMActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled: boolean;
  loading?: boolean;
}

export const GetBOMAction: React.FC<GetBOMActionProps> = ({ className, disabled, loading, ...buttonProps }) => {
  return (
    <button
      {...buttonProps}
      type="button"
      className={classNames(className, style.buttonDisabled)}
      disabled={disabled || loading}
    >
      {loading ? <LoadingSpinner small /> : <FormattedMessage id="actions.getBOM" />}
    </button>
  );
};
